import {
  typedHttpsCallableWrapper,
  typedOnRequestWrapper
} from '../api-_utils';
import { API_ROUTE_CONFIG } from './api-config/config';

export class APIIntegrationImPACT {
  /**
   * Join the ImPACT Pilot
   */
  public static addPatient = typedHttpsCallableWrapper(
    API_ROUTE_CONFIG.clinic.integration.impact.addPatient
  );

  public static generateFakeToken = typedHttpsCallableWrapper(
    API_ROUTE_CONFIG.clinic.integration.impact.token.generateSampleToken
  );
  public static decodeToken = typedHttpsCallableWrapper(
    API_ROUTE_CONFIG.clinic.integration.impact.token.decodeToken
  );

  public static isAssignedToPatientWithPassportId = typedHttpsCallableWrapper(
    API_ROUTE_CONFIG.clinic.integration.impact.isAssignedToPatientWithPassportId
  );

  /**
   * Check if an encrypted token is valid
   */
  public static isTokenValid = typedOnRequestWrapper(
    API_ROUTE_CONFIG.clinic.integration.impact.token.isValid
  );

  public static toOnboarding = typedOnRequestWrapper(API_ROUTE_CONFIG.clinic.integration.impact.pilot.toOnboarding);
  public static getFakePilotRedirectParams = typedOnRequestWrapper(API_ROUTE_CONFIG.clinic.integration.impact.pilot.getFakePilotRedirectParams);
}

export class APIImpact {
  public static generateFakeSubmitUrl = typedHttpsCallableWrapper(
    API_ROUTE_CONFIG.impact.__test__.generateFakeSubmitUrl
  );

  public static impactPassportIdExists = typedHttpsCallableWrapper(
    API_ROUTE_CONFIG.impact.impactPassportIdExists
  );
}
